// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FVgU","badges":"styles_badges__3R8Oy"};